// Your web app's Firebase configuration
export const firebaseConfig = {
	apiKey: 'AIzaSyA8TBjy71X6RuRl3law_aL6frSxwtRy1PI',
	authDomain: 'enlisted-stats.firebaseapp.com',
	projectId: 'enlisted-stats',
	storageBucket: 'enlisted-stats.appspot.com',
	messagingSenderId: '751918453756',
	appId: '1:751918453756:web:07198cee9945c01535d879',
};
